












import {Component, Prop, Vue, Watch} from 'vue-property-decorator';
import dokument from '@/store/modules/dokument';
import {ListSection} from '@/store/models';

@Component({components: {}})
export default class Toggle extends Vue {
  @Prop() readonly section!: any;
  @Prop() readonly disabled!: boolean;

  visible: boolean = true;

  @Watch('section', {immediate: true, deep: true})
  onData() {
    this.visible = !this.section.Hidden;
  }

  @Watch('visible', {immediate: false, deep: false})
  visibleChanged() {
    if (this.section.Hidden === !this.visible) {
      return;
    }
    this.update();
  }

  update() {
    const s = {
      Id: this.section.Id,
      Kind: this.section.Kind,
      Type: this.section.Type,
      SubType: this.section.SubType,
      Hidden: !this.visible,
    };
    if (this.section.Items) {
      (s as any).Items = this.section.Items;
    }
    dokument.updateItem(s);
  }

}
